export default function fetchStorefrontAccessToken(shopLocale, storeHandle) {
	if (storeHandle === 'wellvita-be') {
		return {
			endpoint: "https://wellvita-be.myshopify.com/api/2025-07/graphql.json",
			token: "9cb8d90eba1a79f62e520ccc4e671331"
		};
	}

	switch (shopLocale) {
		case "da":
			return {
				endpoint: "https://wellvita-store.myshopify.com/api/2025-07/graphql.json",
				token: "395ab8b012a29f377a6cb09cb7a26046"
			}
		case "nl":
			return {
				endpoint: "https://nl-wellvita.myshopify.com/api/2025-07/graphql.json",
				token: "e4b08cf54370d0b175e51c616a0d1ea3"
			};
		case "se":
		case "sv":
			return {
				endpoint: "https://se-wellvita.myshopify.com/api/2025-07/graphql.json",
				token: "04feeaa99f2042b19270fc3dd0ad8401"
			};
		case "no":
		case "nb":
			return {
				endpoint: "https://no-wellvita.myshopify.com/api/2025-07/graphql.json",
				token: "ae5df0b33b7325e5ab7873a8918d6cba"
			};
		case "fi":
			return {
				endpoint: "https://fi-wellvita.myshopify.com/api/2025-07/graphql.json",
				token: "e7ad755ced362123dc05a759a3c98c90"
			};
		default:
			return {
				endpoint: "https://wellvita-store.myshopify.com/api/2025-07/graphql.json",
				token: "395ab8b012a29f377a6cb09cb7a26046"
			};
	}
}
